import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ACCOUNT } from 'src/app/accounts';
import { Transfer } from '@contracts/interfaces/transaction.interfaces';
import { BankService } from 'src/app/services/bank.service';

@Component({
  templateUrl: 'payroll-pay.dialog.html',
  styleUrls: ['./payroll-pay.dialog.scss']
})
export class PayPayrollDialogComponent {

  transfers: Transfer[] = [
    { srcAccount: ACCOUNT.WAGES, destAccount: '870196967', amount: 426.08, transactionDescription: 'Summer Wage', name: 'Summer White', isExternal: true },
    { srcAccount: ACCOUNT.WAGES, destAccount: ACCOUNT.BAS, amount: 12.00, transactionDescription: 'PayG' },
    { srcAccount: ACCOUNT.WAGES, destAccount: ACCOUNT.SUPER, amount: 52.57, transactionDescription: 'Super' }
  ];

  constructor(
      @Inject(MAT_DIALOG_DATA) public data: any,
      public dialogRef: MatDialogRef<PayPayrollDialogComponent>,
      public dialog: MatDialog,
      private bankService: BankService) {
        
      }

      submitAbr($event) {

      }

      commit() {
        this.bankService.transfer(this.transfers);
      }

      clear() {
        this.dialogRef.close();
      }

      getTotal() {
        let total = 0;
        this.transfers.forEach(t=> {
          total += t.amount;
        });
        return total;
      }

      save() {

      }
}